<template>
    <div class="root-container">
        <!--图表-->
        <el-row class="box-header">
            <el-col class="chart-title-text-container" :span="12">
                <div class="chart-title-text">{{title}}</div>
                <el-tooltip effect="dark" content="统计单日24小时中每一个小时的在线设备数量" placement="right">
                    <i class="icon-question-circle"></i>
                </el-tooltip>
            </el-col>
            <el-col class="chart-subtitle-text-container" :span="12">
                <div class="chart-subtitle-text">
                    {{endAt}}
                </div>

                <el-date-picker
                  v-model="endAt"
                  type="date"
                  range-separator="至"
                  size="mini"
                  :editable="false"
                  :clearable="true"
                  format="yyyy/M/d"
                  value-format="yyyy/M/d"
                  placeholder="选择查看日期"
                  @change="changeEndAt"
                  :picker-options="pickerOptions"
                  style="width:140px;margin-left: 10px;">
                </el-date-picker>

            </el-col>
        </el-row>
        <el-row class="box-main" style="height: 400px">
            <div class="box-chart" ref="chart_ref" v-loading="loading" element-loading-spinner="el-icon-loading"/>
        </el-row>
        <!--列表-->
        <el-row class="box-header" style="margin-top: 30px">
            <el-col class="chart-title-text-container" :span="12">
                <div class="chart-title-text">单日每个小时的在线设备数量分布明细</div>
            </el-col>
            <el-col class="chart-subtitle-text-container" :span="12">
                <div class="chart-subtitle-text">
                    {{endAt}}
                </div>
            </el-col>
        </el-row>
        <el-row class="box-main" style="height: 400px;">
            <el-table :data="onlineDeviceTimeDetail" max-height="400" v-loading="loading" element-loading-spinner="el-icon-loading">
                <el-table-column label="#" width="50" align="center">
                    <template slot-scope="scope">
                        {{scope.$index+1}}
                    </template>
                </el-table-column>
                <el-table-column prop="hour" label="时段（之后的1小时内）" align="center"/>
                <el-table-column prop="hourly_living" label="在线设备数" align="center"/>
            </el-table>
        </el-row>
        <!--图表-->
        <el-row class="box-header" style="margin-top: 30px">
            <el-col class="chart-title-text-container" :span="12">
                <div class="chart-title-text">{{odTitle}}</div>
                <el-tooltip effect="dark" content="统计在线时长介于某区间范围的台次" placement="right">
                    <i class="icon-question-circle"></i>
                </el-tooltip>
            </el-col>
            <el-col class="chart-subtitle-text-container" :span="12">
                <div class="chart-subtitle-text">
                    截止 {{new Date().getFullYear()+'-'+(new Date().getMonth()+1)+'-'+(new Date().getDate()-1)}}
                </div>
            </el-col>
        </el-row>
        <el-row class="box-main" style="height: 400px">
            <div class="box-chart" ref="pie_chart_ref" v-loading="loading" element-loading-spinner="el-icon-loading"/>
        </el-row>
        <!--列表-->
        <el-row class="box-header" style="margin-top: 30px">
            <el-col class="chart-title-text-container" :span="12">
                <div class="chart-title-text">不同单次在线时长范围的台次分布明细</div>
            </el-col>
            <el-col class="chart-subtitle-text-container" :span="12">
                <div class="chart-subtitle-text">
                    {{new Date().getFullYear()+'-'+(new Date().getMonth()+1)+'-'+(new Date().getDate()-1)}}
                </div>
            </el-col>
        </el-row>
        <el-row class="box-main" style="height: 400px;">
            <el-table :data="onlineDurationDetail" max-height="400" v-loading="loading" element-loading-spinner="el-icon-loading">
                <el-table-column label="#" width="50" align="center">
                    <template slot-scope="scope">
                        {{scope.$index+1}}
                    </template>
                </el-table-column>
                <el-table-column prop="duration" label="单次在线时长范围" align="center"/>
                <el-table-column prop="device_count" label="台次" align="center"/>
            </el-table>
        </el-row>
    </div>
</template>

<script>
    import echarts from 'echarts'
    import {GetOnlineDurationInfo} from "../api/api";

    export default {
        data() {
            return {
                token: '',
                title: '单日每个小时的在线设备数量分布',
                onlineDeviceTimeDetail: [],
                xdata: [],
                ydata: [],
                odTitle: '不同单次在线时长范围的台次分布',
                onlineDurationDetail: [],
                odXData: ['0~1h', '1~8h', '8~24h', '1~5d', '5~30d', '30d以上'],
                odYData: [],
                endAt:'',
                pickerOptions: {
                    disabledDate(time) {
                        // 最晚到昨天
                        let now = new Date()
                        let todayZero = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0)
                        return time.getTime() >= todayZero.getTime();
                    }
                },
                mChart:null,
                mBarChart:null,
                mOption:null,
                mBarOption:null,
                loading:false
            }
        },
        methods: {
            query(){
                this.loading = true

                var that = this
                var params = {
                    token: this.token,
                }
                if (this.endAt) {
                    params['end_at'] = this.endAt
                }
                console.log('params', params)
                GetOnlineDurationInfo(params).then(res => {
                    that.onlineDeviceTimeDetail = res.data.time_interval;
                    console.log('GetOnlineDurationInfo', that.onlineDeviceTimeDetail);

                    that.xdata.splice(0, that.xdata.length)
                    that.ydata.splice(0, that.ydata.length)
                    for (var index in that.onlineDeviceTimeDetail) {
                        that.xdata.push(that.onlineDeviceTimeDetail[index].hour.substring(11, 16));
                        that.ydata.push(that.onlineDeviceTimeDetail[index].hourly_living);
                    }
                    this.mChart.setOption(this.mOption);

                    that.onlineDurationDetail = res.data.reconnections;
                    console.log('onlineDurationDetail', that.onlineDurationDetail);
                    that.odYData.splice(0, that.ydata.length)
                    for (var index in that.onlineDurationDetail) {
                        that.onlineDurationDetail[index].duration = that.odXData[index];
                        that.odYData.push(that.onlineDurationDetail[index].device_count);
                    }
                    console.log('odYData', that.odYData);
                    this.mBarChart.setOption(this.mBarOption);

                    this.loading = false
                }).catch(err => {
                    this.loading = false
                });
            },
            initEndAt() {
                var end = new Date()
                end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
                this.endAt = end.toLocaleDateString()
            },
            changeEndAt(value){
                console.log('changeEndAt', value)
                this.$nextTick(() => {
                    if (!value) {
                        this.initEndAt()
                    }
                    this.query()
                })
            }
        },
        created() {
            this.token = sessionStorage.getItem("BBRtoken");
            this.initEndAt()
        },
        mounted() {
            var that = this;
            // 初始化图表
            this.mChart = echarts.init(this.$refs.chart_ref);
            this.mBarChart = echarts.init(this.$refs.pie_chart_ref);
            this.mOption = {
                color: ['rgb(126,182,234)'],
                tooltip: {
                    trigger: 'axis',
                    formatter: "[{b}后1小时内]<br/>- 在线{c}台"
                },
                grid: {
                    top: '10%',
                    left: '3%',
                    right: '3%',
                    bottom: '10%',
                    containLabel: true
                },
                // legend: {
                //     // data: ['12'],
                //     // left: 'auto',
                //     // type: 'plain',
                //     show: true
                // },
                xAxis: {
                    data: that.xdata,
                    axisLine: {
                        lineStyle: {
                            color: '#d2e2e2'
                        }
                    },
                    axisLabel: {
                        color: '#8492A6',
                        fontWeight: 'bold'
                    }
                },
                yAxis: {
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: ['#e2e2e2'],
                            type: 'dotted'
                        }
                    },
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        color: '#8492A6',
                        fontWeight: 'bold',
                        formatter: '{value}台'
                    }
                },
                series: {
                    name: that.title,
                    type: 'line',
                    data: that.ydata,
                }
            };
            this.mBarOption = {
                color: ['rgb(126,182,234)'],
                tooltip: {
                    trigger: 'axis',
                    formatter: "[在线时长介于{b}]<br/>- {c}台次"
                },
                grid: {
                    top: '10%',
                    left: '3%',
                    right: '3%',
                    bottom: '10%',
                    containLabel: true
                },
                // legend: {
                //     // data: ['12'],
                //     // left: 'auto',
                //     // type: 'plain',
                //     show: true
                // },
                xAxis: {
                    data: that.odXData,
                    axisLine: {
                        lineStyle: {
                            color: '#d2e2e2'
                        }
                    },
                    axisLabel: {
                        color: '#8492A6',
                        fontWeight: 'bold'
                    }
                },
                yAxis: {
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: ['#e2e2e2'],
                            type: 'dotted'
                        }
                    },
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        color: '#8492A6',
                        fontWeight: 'bold',
                        formatter: '{value}台次'
                    }
                },
                series: {
                    name: that.odTitle,
                    type: 'bar',
                    barWidth: '50%',
                    data: that.odYData,
                }
            };
            // 请求数据
            this.query()
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// AnalyzeOnlineDurationManagement.vue?44210bb0